/* device_details.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 18 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M14.6,6c-0.1,0.1-0.1,0.2,0,0.3L17,8.8c0.1,0.1,0.2,0.1,0.3,0l0.4-0.4c0.4-0.4,0.4-1,0-1.4l-1.3-1.3
                    c-0.4-0.4-1.1-0.4-1.5,0L14.6,6z M14,6.9c-0.1-0.1-0.2-0.1-0.3,0l-0.4,0.4l0,0l-5.5,5.5c0,0-0.1,0.1-0.1,0.1l-0.5,2.9
                    c0,0.1,0.1,0.3,0.2,0.2l2.9-0.5c0,0,0.1,0,0.1-0.1l5.5-5.5l0,0l0.4-0.4c0.1-0.1,0.1-0.2,0-0.3L14,6.9z M15.5,9.6l-4.7,4.7l0-0.3
                    c0-0.1-0.1-0.1-0.1-0.2l-0.2-0.1c-0.1-0.1-0.2-0.2-0.1-0.3L14.9,9c0.1-0.1,0.2-0.1,0.3,0l0.3,0.3C15.6,9.4,15.6,9.5,15.5,9.6z
                     M8.5,13.1L9,13.1c0.1,0,0.1,0.1,0.2,0.1l0.2,0.5c0,0,0.1,0.1,0.1,0.1l0.6,0.3c0.1,0,0.1,0.1,0.1,0.2l0,0.4l-0.1,0.1L9.1,15
                    c-0.1,0-0.1,0-0.2-0.1l-0.5-0.5c0,0-0.1-0.1-0.1-0.2L8.5,13.1L8.5,13.1z M9.3,12.3l4.4-4.4c0.1-0.1,0.2-0.1,0.3,0l0.3,0.3
                    c0.1,0.1,0.1,0.2,0,0.3l-4.4,4.4c-0.1,0.1-0.3,0.1-0.3-0.1l0-0.1c0-0.1-0.1-0.1-0.2-0.1l0,0C9.2,12.6,9.2,12.4,9.3,12.3z"/>
                <g>
                    <polygon class="foreground-gl" points="10.5,7.3 10.7,7.7 11.1,7.3 		"/>
                    <path class="foreground-gl" d="M6.4,12.3L5.1,9.2l1,0.4V8.1c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v1.5l1-0.4L7.6,11l2.7-2.9L7,6.7l3.9-1.6
                        l-0.4,1h1.6c0,0,0.1,0,0.1,0l1-1.1c-0.8-2.9-3.4-5-6.5-5C3,0,0,3,0,6.7c0,3.3,2.4,6,5.5,6.6L6.4,12.3z M6.7,0.3l1.6,3.9l-1-0.4
                        v1.5c0,0.3-0.3,0.6-0.6,0.6S6.1,5.6,6.1,5.3V3.7l-1,0.4L6.7,0.3z M1.4,7.3C1.1,7.3,0.8,7,0.8,6.7c0-0.3,0.3-0.6,0.6-0.6H3l-0.4-1
                        l3.9,1.6L2.5,8.3l0.4-1H1.4z"/>
                </g>
            </g>
            </svg>
         `
};
